import { useMemo } from 'react';
import {
  PatientDataPermission,
  useProviderUserMembersV2Query,
} from '../../../../generated/graphql';
import { customToast } from '../../../components/ToastAlert/customToast';

interface UseFilteredProviderUsersParams {
  searchQuery: string;
  selectedProviderUserIds: string[];
}

export const useFilteredProviderUsers = ({
  searchQuery,
  selectedProviderUserIds,
}: UseFilteredProviderUsersParams) => {
  const { data: teamMembersData, loading } = useProviderUserMembersV2Query({
    variables: {
      activeProviderUsersOnly: true,
    },
    onError() {
      customToast.error(
        'Something went wrong getting your team members. Please try refreshing.',
      );
    },
  });

  // Filter out users without patient data permission
  const providerUsersList =
    teamMembersData?.providerUserMembers?.filter(
      (providerUser) =>
        providerUser?.patientDataPermission !== PatientDataPermission.None,
    ) || [];

  // Filter by search query and already selected users
  const filteredProviderUsers = useMemo(() => {
    return providerUsersList
      ?.filter((providerUser) => {
        return !selectedProviderUserIds.includes(providerUser.id);
      })
      ?.filter((providerUser) => {
        if (!searchQuery) return true;
        return providerUser?.name
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase());
      });
  }, [providerUsersList, selectedProviderUserIds, searchQuery]);

  return {
    providerUsersList,
    filteredProviderUsers,
    loading,
  };
};
